import messageHelpers from '../message-helpers';
import actionTypes from './action-types';
import * as api from '../resources/message.api';

export const fetchSentMessagesListRequest = () => ({
  type: actionTypes.FETCH_SENT_MESSAGES_LIST_REQUEST,
  name: 'sentLoadingStatus',
});

export const fetchSentMessagesListFailure = () => ({
  type: actionTypes.FETCH_SENT_MESSAGES_LIST_FAILURE,
  name: 'sentLoadingStatus',
});

export const fetchSentMessagesListSuccess = (messages, pagination) => ({
  type: actionTypes.FETCH_SENT_MESSAGES_LIST_SUCCESS,
  messages: messages.map((message) => {
    const content = messageHelpers.getShortenMessage(message.content);

    return {
      ...message,
      content,
    };
  }),
  pagination,
  name: 'sentLoadingStatus',
});

export const fetchSentMessagesList = (params) => async (dispatch) => {
  try {
    dispatch(fetchSentMessagesListRequest());
    const { content, ...pagination } = await api.fetchSentMessagesList(params);
    dispatch(fetchSentMessagesListSuccess(content, pagination));
  } catch (error) {
    dispatch(fetchSentMessagesListFailure());
    // eslint-disable-next-line no-console
    console.error('FETCH_SENT_MESSAGES_LIST', error);
  }
};

export const fetchAdministratorsSentMessagesList = (params) => async (dispatch) => {
  try {
    dispatch(fetchSentMessagesListRequest());
    const { content, ...pagination } = await api.fetchAdministratorsSentMessagesList(params);
    dispatch(fetchSentMessagesListSuccess(content, pagination));
  } catch (error) {
    dispatch(fetchSentMessagesListFailure());
    // eslint-disable-next-line no-console
    console.error('FETCH_SENT_MESSAGES_LIST', error);
  }
};

export const fetchUserSentMessagesList = (params) => async (dispatch) => {
  try {
    dispatch(fetchSentMessagesListRequest());
    const { content, ...pagination } = await api.fetchUserSentMessagesList(params);
    dispatch(fetchSentMessagesListSuccess(content, pagination));
  } catch (error) {
    dispatch(fetchSentMessagesListFailure());
    // eslint-disable-next-line no-console
    console.error('FETCH_SENT_MESSAGES_LIST', error);
  }
};

export const deleteSentMessagesRequest = () => ({
  type: actionTypes.DELETE_SENT_MESSAGES_REQUEST,
});

export const deleteSentMessagesFailure = () => ({
  type: actionTypes.DELETE_SENT_MESSAGES_FAILURE,
});

export const deleteSentMessagesSuccess = (messages) => ({
  type: actionTypes.DELETE_SENT_MESSAGES_SUCCESS,
  messages,
});

export const deleteSentMessages = () => async (dispatch, getStore) => {
  try {
    const { messages } = getStore();
    const { sent: entries, selectedMessages } = messages;
    const { selectedMessagesList } = selectedMessages;

    dispatch(deleteSentMessagesRequest());
    await api.deleteSentMessages(selectedMessagesList);
    dispatch(deleteSentMessagesSuccess(entries));
  } catch (error) {
    dispatch(deleteSentMessagesFailure());
    // eslint-disable-next-line no-console
    console.error('DELETE_SENT_MESSAGES', error);
  }
};

export const deleteSentMessageRequest = () => ({
  type: actionTypes.DELETE_SENT_MESSAGE_REQUEST,
});

export const deleteSentMessageFailure = () => ({
  type: actionTypes.DELETE_SENT_MESSAGE_FAILURE,
});

export const deleteSentMessageSuccess = () => ({
  type: actionTypes.DELETE_SENT_MESSAGE_SUCCESS,
});

export const deleteSentMessage = (id) => async (dispatch) => {
  try {
    dispatch(deleteSentMessageRequest());
    await api.deleteSentMessages([id]);
    dispatch(deleteSentMessageSuccess());
  } catch (error) {
    dispatch(deleteSentMessageFailure());
    // eslint-disable-next-line no-console
    console.error('DELETE_SENT_MESSAGE', error);
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/actions/sent.actions.js